import { useEffect, useState } from 'react';

function ScrollToTopBadge() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <div
      onClick={scrollToTop}
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px', // ⬅️ untere linke Ecke
        width: '40px',
        height: '40px',
        backgroundColor: '#4285F4',
        borderRadius: '50%',
        color: 'white',
        fontSize: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 1000,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
      }}
      title="Nach oben"
    >
      ↑
    </div>
  );
}

export default ScrollToTopBadge;
